import noty from '@/plugins/noty'

export const errorNotification = ({ message }) => {
  return noty({
    type: 'error',
    timeout: 10000,
    text: message
  })()
}



// WEBPACK FOOTER //
// ./src/components/shared/SearchContacts/SearchMode/notifications.js